import api from './api.config'
const serverUrl = api.url.main
const serverUrl1 = api.url.mainProcess

//下部为测试环境
// const serverUrl = 'https://testapi.hive-intel.com/main'
// const serverUrl1 = 'https://testapi.hive-intel.com/remain-processer'
// const serverUrl = 'http://172.168.1.116:10083'

//下部为本地连接测试链接
// const serverUrl = 'http://172.168.150.124:10083'
// const serverUrl1 = 'http://172.168.1.173:10090'

//下部为mock环境
// const serverUrl1 = 'http://yapi.hive-intel.com/mock/13'

//http://localserver.hivetech.iego.net:81/main(这个是测试环境 主项目从外部访问的地址)

//腾讯部分（输入提示）
const TencentUrl = 'https://apis.map.qq.com'
const TencentKey = 'DH6BZ-STTKW-QOKRH-R56NM-B3UOT-UKB3T'

export { serverUrl, serverUrl1, TencentUrl, TencentKey }



// WEBPACK FOOTER //
// ./src/utils/config.js